import LocalRepository from "../../repository/LocalRepository";

const state = () => ({
    user: LocalRepository.getUser(),
})

const getters = {
    user: (state) => {
        return state.user
    },

    nim: (state) => {
        return state.user.user.username
    },

    isLogin: (state, getters, rootState) => {
        return state.user != null
    },

    token: (state) => {
        return state.user?.token ?? null
    },

    role: (state) => {
        return state.user?.role ?? null
    },

    isUserKoas: (state, getters, rootState) => {
        return state.user != null && state.user.role === 'koas'
    },

    isUserDokter: (state, getters, rootState) => {
        return state.user != null && state.user.role === 'dokter'
    },

    isUserPjBahan: (state, getters, rootState) => {
        return state.user != null && state.user.role === 'pj_bahan'
    },

    isUserAdmin: (state, getters, rootState) => {
        return state.user != null && state.user.role === 'admin'
    },

    isUserPendidikan: (state, getters, rootState) => {
        return state.user != null && state.user.role === 'pendidikan'
    },

    isUserDev: (state, getters, rootState) => {
        return state.user != null && state.user.role === 'dev'
    },
}

const actions = {
    login({ state, commit }, user) {
        commit('login', user)
    },

    logout({ state, commit }) {
        commit('logout')
    }
}

const mutations = {
    login(state, user) {
        state.user = user
        LocalRepository.login(user)
    },

    logout(state) {
        state.user = null
        LocalRepository.logout()
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}